import * as Yup from 'yup';

export const buildValidationSchema = (data, t) => {
  const questionnaireShape = data.questionnaire?.questions.reduce((acc, item) => {
    let schema = Yup.string();
    if (item.is_required) {
      schema = schema.required(t('compliance:validation.field_required'));
    }
    if (item.max_length) {
      schema = schema.max(
        item.max_length,
        t('compliance:validation.field_max_length', { max: item.max_length }),
      );
    }
    acc[item.id] = schema;
    return acc;
  }, {}) || {};

  const documentsShape = data.documents?.required_documents?.reduce((acc, doc) => {
    acc[doc.document_type] = doc.is_required
      ? Yup.array().min(1, t('compliance:validation.file_required'))
      : Yup.array();
    return acc;
  }, {}) || {};

  return Yup.object({
    questionnaire: Yup.object(questionnaireShape),
    documents: Yup.object(documentsShape),
    has_accepted: Yup.boolean().isTrue(t('compliance:validation.accept_terms')),
  });
};
